export const challengeBank = [
  {
    "id": "worst-dst-win",
    "text": "Win your matchup while starting the worst-projected defense",
    "faab": 20
  },
  {
    "id": "bench-top-projected",
    "text": "Win your matchup while benching your highest-projected player for the week",
    "faab": 35
  },
  {
    "id": "same-last-name-trio",
    "text": "Win your matchup while starting three players who share the same last name in your lineup",
    "faab": 40
  },
  {
    "id": "same-nfl-team-four",
    "text": "Win your matchup while starting at least four players from the same NFL team",
    "faab": 30
  },
  {
    "id": "te-in-flex",
    "text": "Win your matchup while starting a tight end in your FLEX spot",
    "faab": 20
  },
  {
    "id": "college-trio",
    "text": "Win your matchup while starting three players who went to the same college in your lineup",
    "faab": 35
  },
  {
    "id": "skip-top-wr",
    "text": "Win your matchup without starting your highest-projected wide receiver",
    "faab": 30
  },
  {
    "id": "skip-top-rb",
    "text": "Win your matchup without starting your highest-projected running back",
    "faab": 30
  },
  {
    "id": "worst-rb-slot",
    "text": "Win your matchup while starting your lowest-projected RB in a running back slot",
    "faab": 15
  },
  {
    "id": "backup-qb-gamble",
    "text": "Win your matchup while starting the lower-projected of the two QBs on your roster (if you only roster one QB, you must add a worse one and start them)",
    "faab": 20
  },
  {
    "id": "flex-trap",
    "text": "Win your matchup while starting your lowest-projected flex-eligible player in FLEX",
    "faab": 20
  },
  {
    "id": "all-one-conference",
    "text": "Win your matchup while every starter — including FLEX, K, and D/ST — is from the same conference (all AFC or all NFC)",
    "faab": 35
  },
  {
    "id": "same-letter-trio",
    "text": "Win your matchup while starting three players whose last names start with the same letter",
    "faab": 20
  },
  {
    "id": "empty-rb-slot",
    "text": "Win your matchup while leaving at least one running back slot empty in your starting lineup",
    "faab": 30
  },
  {
    "id": "fade-your-stud",
    "text": "Win your matchup while benching the player you drafted highest this year",
    "faab": 25
  },
  {
    "id": "underdog-kicker",
    "text": "Win your matchup while starting a kicker whose NFL team is the biggest underdog of the week",
    "faab": 15
  },
  {
    "id": "no-elite-starters",
    "text": "Win your matchup without starting anyone on your roster projected as a top-5 player at their position for the week",
    "faab": 30
  },
  {
    "id": "jersey-single-digit-trio",
    "text": "Win your matchup while starting three players with single-digit jersey numbers (0–9)",
    "faab": 25
  },
  {
    "id": "same-last-name-duo",
    "text": "Win your matchup while starting two players with the same last name",
    "faab": 20
  },
  {
    "id": "empty-qb-slot",
    "text": "Win your matchup while leaving your quarterback slot empty in your starting lineup",
    "faab": 50
  }
];
export default challengeBank;
